import cx from 'classnames'
import { Scrollable } from 'components/scrollable'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { ComponentType } from 'react'
import { Col, Container, Row } from 'reactstrap'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

const Wrapper = styled(Scrollable)`
  background: #f8f9fa;
  box-shadow: 0 1px 0 0 rgba(229, 232, 236, 0.5);
  position: sticky;
  top: 70px;
  z-index: 10;
  overflow: auto;

  ${up('sm')} {
    background: transparent;
    box-shadow: none;
    overflow: auto;
    position: relative;
    top: 0;
  }
`

const Content = styled.div`
  display: flex;
  padding: 20px 0;

  ${up('sm')} {
    padding: 40px 0;
  }
`

export const AboutNav: ComponentType = () => {
  const router = useRouter()

  return (
    <Wrapper>
      <Container>
        <Row>
          <Col>
            <Content>
              <Link href="/acerca">
                <a
                  title="Sobre Nosotros"
                  className={cx('nav-anchor pl-0', {
                    active: router.route === '/acerca',
                  })}
                >
                  Sobre Nosotros
                </a>
              </Link>
              <Link href="/acerca/asesores">
                <a
                  title="Asesores Certificados"
                  className={cx('nav-anchor', {
                    active: router.route === '/acerca/asesores',
                  })}
                >
                  Asesores Certificados
                </a>
              </Link>
              <Link href="/acerca/testimoniales">
                <a
                  title="Testimoniales"
                  className={cx('nav-anchor', {
                    active: router.route === '/acerca/testimoniales',
                  })}
                >
                  Testimoniales
                </a>
              </Link>
              <Link href="/acerca/promueve-tu-propiedad">
                <a
                  title="Promueve tu Propiedad"
                  className={cx('nav-anchor', {
                    active: router.route === '/acerca/promueve-tu-propiedad',
                  })}
                >
                  Promueve tu Propiedad
                </a>
              </Link>
            </Content>
          </Col>
        </Row>
      </Container>
    </Wrapper>
  )
}
